// extracted by mini-css-extract-plugin
export default {"more":"TagPicker_more_OlERJ","brandTheme":"TagPicker_brandTheme_drI6W"};